import { Component, OnDestroy, OnInit } from '@angular/core';
import { LanguageSwitcherComponent } from '../../../shared/language-switcher/language-switcher.component';
import { ConfigService } from '../../../services/config/config.service';
import { PipesModule } from '../../../pipes/pipes.module';
import { SocialMedia } from '../../../models/util/socialMedia';
import { MaterialModule } from '../../../material/material.module';
import { GetLanguageService } from '../../../services/translations/translations.service';
import { RouterModule } from '@angular/router';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { DirectiveModule } from '../../../directives/directive.module';
import { PermissionsEnum } from '../../../enums/permissions.enum';
@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [LanguageSwitcherComponent, PipesModule, MaterialModule, RouterModule, DirectiveModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnInit, OnDestroy {

	projectLogo: string;
	socialMedia: SocialMedia[] = [];
	availableLanguages: string[]= [];
	isSmallScreen: boolean = false;
	private subscription: Subscription;
	Permissions = PermissionsEnum;

	constructor(
		public getLanguageService: GetLanguageService,
		private configService: ConfigService,
		private breakpointObserver: BreakpointObserver
	) { }

	ngOnInit(): void {
		this.subscription = this.breakpointObserver.observe(['(max-width: 768px)']).subscribe(value => {
			this.isSmallScreen = value.matches;
		});
		const config = this.configService.getConfig();
		this.projectLogo = config.footerLogo;
		this.socialMedia = config.socialMedia;
		this.availableLanguages = this.configService.getTenantLanguages();
	}

	ngOnDestroy(): void {
		this.subscription?.unsubscribe();
	}

	openLink(link:string){
		window.open(`https://${link}`, '_blank');

	}

	changeLanguage(language: string) {
		if (!language) {
			return;
		}

		this.getLanguageService.setLanguage(language);
	}

}
